import { colorName } from "@domain/Utilities";
import { VisuallyHidden } from "./VisuallyHidden";

interface SwatchTextProps {
	/** The CSS color the legend paints this row's swatch with. */
	color: string;
}

/**
 * The text equivalent of a legend's color swatch — "(shown blue on the map)".
 *
 * A legend's whole job is to carry a color → meaning mapping, and that mapping is the one part of
 * it that never reaches the accessibility tree: the row's label is text, but the swatch beside it
 * is a `background-color` with no textual counterpart. An agent can therefore read *that* a map
 * has a "Robot" layer, and can see red geometry on the canvas, without any way to connect the two.
 *
 * Renders nothing when the color can't be parsed — an unnamed swatch is better than a wrong one.
 *
 * Place it inside the element that supplies the control's accessible name (a `FormControlLabel`'s
 * `label`, the legend row's text) so the description is folded into that name rather than
 * floating loose in the tree.
 */
export function SwatchText({ color }: SwatchTextProps) {
	const name = colorName(color);
	if (name === null) return null;
	return <VisuallyHidden>{` (shown ${name} on the map)`}</VisuallyHidden>;
}
